import { CancelToken } from "axios";

import { IAPIError } from "shared/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IUserPassportPatchData } from "Bands/types";

interface IJSONAPIData {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIUserPassportCollection {
  [IDataKeys.userPassport]: IJSONAPIData;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class UserPassportService {
  static createUserPassport = (
    data: IUserPassportPatchData
  ): Promise<IJSONAPIUserPassportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.post({
          path: API_ENDPOINTS.USER_PASSPORTS,
          data,
        });
        resolve(response as IJSONAPIUserPassportCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.POST_USER_PASSPORT);
        reject({ error });
      }
    });

  static getUserPassports = (
    queryParams?: string | { [key: string]: string | number | undefined | string[] },
    cancelToken?: CancelToken
  ): Promise<IJSONAPIUserPassportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.get({
          path: API_ENDPOINTS.USER_PASSPORTS,
          data: queryParams,
          cancelToken,
        });
        resolve(response as IJSONAPIUserPassportCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_USER_PASSPORTS);
        reject({ error });
      }
    });

  static editUserPassport = (
    id: string,
    data: IUserPassportPatchData
  ): Promise<IJSONAPIUserPassportCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const response: unknown = await APIService.patch({
          path: API_ENDPOINTS.USER_PASSPORT(id),
          data,
        });
        resolve(response as IJSONAPIUserPassportCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_USER_PASSPORT);
        reject({ error });
      }
    });

  static deleteUserPassport = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.USER_PASSPORT(id),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_USER_PASSPORT);
        reject({ error });
      }
    });
}
